// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'
import '@/styles/index.scss'// global css
// 请求方法封装
import apis from './api/service'
import interfaceList from '@/api/interface/index'

Vue.config.productionTip = false

Vue.use(ElementUI).use(apis)

// 配置项目名称
var urlArray = window.location.href.split('/')
var projectName = urlArray[3]
store.commit('SET_PROJECTNAME', projectName)
interfaceList.getSysTime().then(resData => {
  var nowTime = new Date().getTime()
  var sysTime = resData.data.data.timestamp
  store.commit('SET_SYSTIME', sysTime - nowTime)
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
})
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js